// Field schemas for each prototype form. Kept declarative so the
// accessible ProtoForm engine can render + validate them uniformly.

export const contactFields = [
  { name: "firstName", label: "First name", type: "text", required: true },
  { name: "lastName", label: "Last name", type: "text", required: true },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "phone", label: "Phone", type: "tel" },
  {
    name: "inquiryType",
    label: "Inquiry type",
    type: "select",
    required: true,
    options: [
      "In-Suite Massage",
      "Mobile Massage",
      "Corporate Wellness",
      "Partnership",
      "General Question",
    ],
  },
  {
    name: "preferredContact",
    label: "Preferred contact method",
    type: "select",
    required: true,
    options: ["Email", "Phone", "Text"],
  },
  { name: "message", label: "Message", type: "textarea", required: true, full: true },
];

export const corporateFields = [
  { name: "companyName", label: "Company name", type: "text", required: true },
  { name: "contactName", label: "Contact name", type: "text", required: true },
  { name: "jobTitle", label: "Job title", type: "text" },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "phone", label: "Phone", type: "tel", required: true },
  {
    name: "industry",
    label: "Industry",
    type: "select",
    required: true,
    options: [
      "Manufacturing",
      "Healthcare",
      "Oil & Gas",
      "Aviation",
      "Corporate Office / Large Employer",
      "Other",
    ],
  },
  { name: "headcount", label: "Estimated employee or attendee count", type: "text" },
  {
    name: "serviceInterest",
    label: "Service interest",
    type: "select",
    required: true,
    options: [
      "Corporate Chair Massage",
      "Corporate Table Massage",
      "Employee-Appreciation Event",
      "Health & Wellness Fair",
      "Recurring Program",
      "Workplace Activation",
    ],
  },
  {
    name: "engagementType",
    label: "One-time event or recurring program",
    type: "select",
    required: true,
    options: ["One-time event", "Recurring program", "Not sure yet"],
  },
  { name: "preferredDate", label: "Preferred date", type: "date" },
  {
    name: "frequency",
    label: "Frequency (if recurring)",
    type: "select",
    options: ["Weekly", "Bi-weekly", "Monthly", "Quarterly", "Not applicable"],
  },
  { name: "serviceLocation", label: "Service location / venue", type: "text" },
  { name: "city", label: "City", type: "text", required: true },
  {
    name: "preferredContact",
    label: "Preferred contact method",
    type: "select",
    required: true,
    options: ["Email", "Phone", "Text"],
  },
  { name: "additionalInfo", label: "Additional information", type: "textarea", full: true },
];

export const partnershipFields = [
  { name: "name", label: "Name", type: "text", required: true },
  { name: "organization", label: "Organization", type: "text", required: true },
  { name: "role", label: "Role", type: "text" },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "phone", label: "Phone", type: "tel" },
  {
    name: "partnershipType",
    label: "Partnership type",
    type: "select",
    required: true,
    options: [
      "Corporate",
      "Apartment / Residential Community",
      "Fitness & Wellness",
      "Event Collaboration",
      "Retreat",
      "Brand Ambassador",
      "Vendor",
      "Healthcare / Wellness Referral",
    ],
  },
  { name: "opportunity", label: "Proposed opportunity", type: "text", full: true },
  { name: "location", label: "Location", type: "text" },
  {
    name: "preferredContact",
    label: "Preferred contact method",
    type: "select",
    required: true,
    options: ["Email", "Phone", "Text"],
  },
  { name: "message", label: "Message", type: "textarea", required: true, full: true },
];

export const therapistFields = [
  { name: "name", label: "Name", type: "text", required: true },
  { name: "email", label: "Email", type: "email", required: true },
  { name: "phone", label: "Phone", type: "tel" },
  { name: "city", label: "City", type: "text", required: true },
  {
    name: "licenseStatus",
    label: "License status",
    type: "select",
    required: true,
    options: [
      "Licensed (TX)",
      "Licensed (other state)",
      "In training / student",
      "Recently graduated",
      "Other",
    ],
  },
  {
    name: "experience",
    label: "Years of experience",
    type: "select",
    options: ["Less than 1", "1–3", "3–5", "5–10", "10+"],
  },
  {
    name: "serviceInterests",
    label: "Service interests",
    type: "select",
    required: true,
    options: [
      "In-Suite Massage",
      "Mobile Massage",
      "Corporate Chair Massage",
      "Corporate Table Massage",
      "Corporate Wellness",
      "Open to Multiple Settings",
    ],
  },
  { name: "availability", label: "Availability", type: "text" },
  { name: "message", label: "Message", type: "textarea", full: true },
];
